import * as types from '../constants/actionTypes'
import { handleError } from '../utils/handle-error'
import { getBackorderNonVerifiedParcels } from '../utils/terminal-sorting-webapi'

export const dataLoaded = (nonVerifiedParcels) => ({
    type: types.BACKORDER_LOADED,
    status: 200,
    nonVerifiedParcels,
})

export const dataReset = () => ({
    type: types.BACKORDER_RESET,
})

export const unifiedTerminalsWithBackorderingActive = [
    29, // STOCKHOLM_BRUNNA
    85, // OSLO
]

export const fetchData = (terminalId) => (dispatch) => {
    return getBackorderNonVerifiedParcels(terminalId)
        .then((nonVerifiedParcels) => dispatch(dataLoaded(nonVerifiedParcels)))
        .catch(handleError)
}
